import React from 'react';
import { Edit } from 'react-admin';

import TerritorioForm from '../TerritorioForm';

function TerritorioEdit(props) {
    return (
        <Edit {...props}>
            <TerritorioForm />
        </Edit>
    );
}

export default TerritorioEdit;
